import type { RouteRecordRaw } from 'vue-router'

import type { AccessLevel } from '@/types/auth.types'

/**
 * Partner-portal route table. Owned by `portal-fe` (phase 2b). Three
 * public-facing screens: Home, Codici (coupons), Pagamenti (payments).
 *
 * Conventions:
 *   • path prefix: `/portal/...`
 *   • lazy-loaded view components — keeps the partner bundle below the
 *     threshold the chunk-error handler trips on.
 *   • access gated to admin / manager (so internal staff can preview
 *     what a partner sees) and partner roles. Phase 3 wires `App.vue`
 *     to wrap any `/portal/*` route in `PortalShell`, so views render
 *     content only.
 */
const PARTNER_VISIBLE: AccessLevel[] = [
  'access_level.admin',
  'access_level.manager',
  'access_level.partner',
]

export const portalRoutes: RouteRecordRaw[] = [
  {
    path: '/portal',
    name: 'portal-home',
    component: () => import('@/views/portal/HomeView.vue'),
    meta: { access_levels: PARTNER_VISIBLE },
  },
  {
    path: '/portal/coupons',
    name: 'portal-coupons',
    component: () => import('@/views/portal/CouponsView.vue'),
    meta: { access_levels: PARTNER_VISIBLE },
  },
  {
    path: '/portal/payments',
    name: 'portal-payments',
    component: () => import('@/views/portal/PaymentsView.vue'),
    meta: { access_levels: PARTNER_VISIBLE },
  },
]
